import { Box, Typography } from '@mui/material';
import { primary } from '@/theme/colors';

export const NoReportFound = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: '20%',
      }}
    >
      <img
        src="/assets/icons/search-icon.svg"
        alt="no reports found"
        width="100px"
        height="100px"
      />
      <Typography
        color={primary.light}
        variant="body2"
        sx={{
          mt: 2,
        }}
      >
        This report does not exist
      </Typography>
    </Box>
  );
};
